import { FC } from 'react'
import styles from 'components/features/coaching/advisorVideoCall/ControlPanel/ControlPanel.styl'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { MicControl } from 'components/features/coaching/advisorVideoCall/MicControl/MicControl'
import { CamControl } from 'components/features/coaching/advisorVideoCall/CamControl/CamControl'
import { ScreenShareControl } from 'components/features/coaching/advisorVideoCall/ScreenShareControl/ScreenShareControl'
import { isMobileSelector } from 'selectors/viewportSelectors'

type ControlPanelProps = {
  isFullScreen: boolean
}

export const ControlPanel: FC<ControlPanelProps> = (props) => {
  const { isFullScreen } = props

  const callState = useStoreSelector((state) => state.app.videoCall.client.state)
  const isMobile = useStoreSelector(isMobileSelector)

  return (
    <div className={ styles.controlPanel } >
      <div className={ styles.item }>
        <MicControl isFullScreen={ isFullScreen } />
      </div>
      <div className={ styles.item }>
        <CamControl isFullScreen={ isFullScreen } />
      </div>
      { callState === 'active' && !isMobile && (
        <div className={ styles.item }>
          <ScreenShareControl isFullScreen={ isFullScreen } />
        </div>
      )}
    </div>
  )
}
